import { Moment } from 'moment';
import { TipoPortaria } from './tipo-portaria.model';

export class Portaria {

  id: number;
  tipoPortaria: TipoPortaria;
  numero: number;
  data: Moment;
  dataDou: Moment;
  descricao: string;
  titulo: string;

}
